import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AuthService } from '../../../../../core/auth';
import { GeneralAutocompleteComponent } from '../../../../partials/layout/general-autocomplete/general-autocomplete.component';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

@Component({
  selector: 'kt-copy-role-template-permission-dialog',
  templateUrl: './copy-role-template-permission-dialog.component.html',
  styleUrls: ['./copy-role-template-permission-dialog.component.scss'],
})
export class CopyRoleTemplatePermissionDialogComponent implements OnInit, OnDestroy {
  roleCtrl = new FormControl();
  roleTemplate = null;
  searchRoleTemplatesFn = this.authService.searchRoleTemplates.bind(this.authService);
  formatNewRoleTemplateFn = ((value) => {
    return value;
  }).bind(this);
  private subscriptions: Subscription[] = [];
  isSuperAdmin = false;
  @ViewChild('roleTemplateAutoComplete') roleTemplateAutoComplete: GeneralAutocompleteComponent;
  private selectedRoleTemplate: any;
  disableBtns = false;

  constructor(
    public authService: AuthService,
    public dialogRef: MatDialogRef<CopyRoleTemplatePermissionDialogComponent>,
  ) {}

  ngOnInit() {
    console.log('');
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  onSubmit() {
    if (this.roleTemplateAutoComplete.controlObject.invalid) {
      this.roleTemplateAutoComplete.updateValueAndValidity();
      return;
    }
    this.disableBtns = true;
    this.authService
      .findRoleTemplates({
        filter: {
          title: this.selectedRoleTemplate.name,
          searchData: this.selectedRoleTemplate.name,
          isActive: 'true',
        },
        pageNumber: 0,
        pageSize: 10,
        sortField: 'id',
        sortOrder: 'asc',
      })
      .subscribe((res) => {
        this.dialogRef.close(
          res &&
            res.pageOfItems &&
            res.pageOfItems[0] &&
            res.pageOfItems[0].permissions &&
            res.pageOfItems[0].permissions.length
            ? res.pageOfItems[0].permissions
            : [],
        );
      });
  }

  filterRoleTemplateFn(event: any): string {
    return event ? event.name : '';
  }

  selected(val): void {
    this.selectedRoleTemplate = val;
  }
}
